<script>
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import { completemsg, apply } from "../stores.js";

  onMount(async () => {
    window.scroll(0, 0);
    if (!$apply || !$apply.complete) {
      push("/");
    }
  });
</script>

<h2>{$completemsg.header}</h2>
{#each $completemsg.body.lines as line}
<p class="ws-pl">{line}</p>
{/each}
<h6>メールが届かない場合は以下をご確認ください。</h6>
<ul>
  <li>迷惑メールボックスやごみ箱フォルダに入っていないかご確認ください。</li>
  <li>上記をご確認いただき、申込完了通知が届いていない場合は、「funity-rs.jp」からメールを受信出来るように設定のうえ、再度受付サイトにてメールアドレスの登録から、手続きを行ってください。</li>
</ul>
<p>※お申込みは先着順となります。予定数に達し次第、締め切りとさせていただきます。</p>
